import React, { useMemo, useState } from 'react';

import _ from 'lodash';

import AuditTrailItem from '../audit-trail-item';
import Conditional from '../../common/conditional';
import Pagination from '../pagination';

import useAuditTrail from '../../../hooks/useAuditTrail';
import classNames from './style.module.scss';

import { formatTime, paginate } from '../../../utils/utilities';
import { SortColumn } from '../../../utils/models';

interface ReportProgressTrailProps {
	projectId?: string;
}

const ReportProgressTrail: React.FC<ReportProgressTrailProps> = ({ projectId }) => {
	const [currentPage, setCurrentPage] = useState<number>(1);
	const pageSize = 5;

	const { progressTrail } = useAuditTrail(projectId!);
	const { paginated, count } = useMemo(() => {
		const alteredTrail = progressTrail.filter((item) => item.description);
		const sorted = _.orderBy(alteredTrail,[sortColumn.path],[sortColumn.order]);
		const paginated = paginate(sorted, currentPage, pageSize);

		return { paginated, count: alteredTrail.length };
	}, [currentPage, progressTrail, pageSize]);

	return (
		<Conditional isVisible={paginated.length > 0}>
			<div className={classNames.progressTrail}>
				<div className="p-3 bg-light border">
					{paginated.map((trailItem, index) => (
						<div key={trailItem._id} className={classNames.progressTrailItem}>
							<AuditTrailItem label="Change by" value={trailItem.userName} />
							<AuditTrailItem label="Designation" value={trailItem.userDesignation}/>
							<AuditTrailItem label="Description" value={trailItem.description} />
							<AuditTrailItem label="Change Date" value={formatTime(trailItem.createdAt)}/>
						</div>
					))}

					<div className="d-flex justify-content-end">
						<div className="d-inline-block bg-white border">
							<Pagination
								itemsCount={count}
								pageSize={pageSize}
								currentPage={currentPage}
								onPageChange={(page) => setCurrentPage(page)}
							/>
						</div>
					</div>
				</div>
			</div>
		</Conditional>
	);
};

const sortColumn: SortColumn = {
	path: 'createdAt',
	order: 'desc',
};

export default ReportProgressTrail;
